import gql from "graphql-tag"
import {
  TagsDocument,
  CreateTagDocument,
  UpdateTagDocument,
  DeleteTagDocument,
  CreateTagAttachmentDocument,
  UpdateTagAttachmentDocument,
  DeleteTagAttachmentDocument,
  CreateTagLinkDocument,
  DeleteTagLinkDocument,
  TagAttachmentFragmentDoc,
  TagFragmentDoc,
  TagLinkFragmentDoc
} from "@pathwright/graphql-client/src/generated"

export const TAG_FRAGMENT = TagFragmentDoc

export const TAG_ATTACHMENT_FRAGMENT = TagAttachmentFragmentDoc

export const TAG_LINK_FRAGMENT = TagLinkFragmentDoc

export const TAGS_QUERY = TagsDocument

export const TAG_ATTACHMENTS_QUERY = gql`
  query TagAttachments($context: TagAttachmentContextInput) {
    tagAttachments(first: 1042, context: $context) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...TagAttachment
          tag {
            ...Tag
          }
        }
      }
    }
  }
  ${TAG_ATTACHMENT_FRAGMENT}
`

export const CREATE_TAG_MUTATION = CreateTagDocument

export const UPDATE_TAG_MUTATION = UpdateTagDocument

export const DELETE_TAG_MUTATION = DeleteTagDocument

export const CREATE_TAG_ATTACHMENT_MUTATION = CreateTagAttachmentDocument

export const UPDATE_TAG_ATTACHMENT_MUTATION = UpdateTagAttachmentDocument

export const DELETE_TAG_ATTACHMENT_MUTATION = DeleteTagAttachmentDocument

export const CREATE_TAG_LINK_MUTATION = CreateTagLinkDocument

export const DELETE_TAG_LINK_MUTATION = DeleteTagLinkDocument
